"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports["default"]=_identity;function _identity(a){return a}